import { Modal } from 'react-bootstrap'
import { KTSVG } from '../_metronic/helpers'
import { useEffect, useState } from 'react'

type CustomInputProps = {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
  className?: string
  type?: 'text' | 'password'
}

export const CustomInputBox = ({
  value,
  onChange,
  disabled = false,
  className = '',
  type = 'text',
}: CustomInputProps) => {
  const [isFocused, setIsFocused] = useState(false)

  const baseClasses = 'form-control fw-normal h-38px'
  const focusClasses = isFocused ? 'border-primary shadow-sm' : 'border-gray-300'
  const disabledClasses = disabled ? 'bg-gray-100 text-gray-500' : 'bg-white'

  const finalClassName = `${baseClasses} ${focusClasses} ${disabledClasses} ${className}`.trim()

  return (
    <input
      type={type}
      className={finalClassName}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      disabled={disabled}
      autoComplete='off'
    />
  )
}

type DeletePopupProps = {
  showModel: boolean
  setShowModel: (value: boolean) => void
  primaryAction?: Function
  secondaryAction?: Function
  loading: boolean
  primaryButtonText?: string
  secondaryButtonText?: string
  title?: string
  description?: string
  notes?: string
  confirmText?: string
  currentValue?: string
}
export function DeleteConfirmPopup(props: DeletePopupProps) {
  const [inputValue, setInputValue] = useState<string>('')
     useEffect(() => {
    if (!props.showModel) {
      setInputValue('')
    }
  }, [props.showModel, props.currentValue])

  const isConfirmationValid = props.currentValue ? inputValue === props.currentValue : true
  return (
    <>
      <Modal
        id='kt_modal_add_inv'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-500px '
        show={props.showModel}
        onHide={() => props.setShowModel(false)}
      >
        <Modal.Body className='p-9'>
          <div className='card'>
            <div className='card-body p-0'>
              <h2 className='fw-bolder text-gray-heading pb-4 d-flex flex-row'>
                <div className='col-1 mt-2'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen027.svg'
                    className='svg-icon-2x text-danger bg-danger-badge p-3 rounded-circle pb-4'
                  />
                </div>
                <span className='col-10 ms-5'>
                  {props.title}
                  <div className='fs-8 pb-6 text-gray-500'>{props.description}</div>
                </span>
              </h2>
              {props.notes && (
                <div className='fs-8 fw-normal pb-4'>
                  <b>Note : </b> {props.notes}
                </div>
              )}
              <div className='fv-row mb-4'>
                <p className='fs-8 fw-bold mb-2'>{props.confirmText}</p>
                <CustomInputBox
                  value={inputValue}
                  onChange={setInputValue}
                  disabled={props.loading}
                  className='border-2'
                />
              </div>
              <div className='d-flex col justify-content-between pt-4'>
                <button
                  className='px-4 rounded border border-1 bg-hover-secondary border-primary bg-transparent h-38px fw-normal text-primary'
                  onClick={() => {
                    props.setShowModel(false)
                    props.secondaryAction && props.secondaryAction()
                  }}
                >
                  <span className='indicator-label'>{props.secondaryButtonText || 'Cancel'}</span>
                </button>
                <button
                  type='submit'
                  className={`px-4 rounded border border-0 border-primary ${
                    !isConfirmationValid ? 'disabled bg-gray-500 ' : 'bg-primary'
                  } h-38px fw-normal text-white `}
                  disabled={props.loading || !isConfirmationValid}
                  onClick={(e) => {
                    props.primaryAction && props.primaryAction(e)
                  }}
                >
                  {!props.loading && (
                    <div className='d-flex align-items-center'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen027.svg'
                        className='svg-icon-3 text-white'
                      />
                      {props.primaryButtonText || 'Delete'}
                    </div>
                  )}
                  {props.loading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Please wait...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}
